import type { MarkdownSection } from "@/shared/types/estateEssentials";

function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

export function parseMarkdownSections(markdown: string): MarkdownSection[] {
  const lines = markdown.split("\n");
  const sections: MarkdownSection[] = [];
  let currentTitle = "";
  let currentLines: string[] = [];

  for (const line of lines) {
    if (line.startsWith("# ")) {
      if (currentTitle) {
        sections.push({
          id: slugify(currentTitle),
          title: currentTitle,
          content: currentLines.join("\n").trim(),
        });
      }
      currentTitle = line.slice(2).trim();
      currentLines = [];
    } else if (currentTitle) {
      currentLines.push(line);
    }
  }

  if (currentTitle) {
    sections.push({
      id: slugify(currentTitle),
      title: currentTitle,
      content: currentLines.join("\n").trim(),
    });
  }

  return sections;
}
